import React, { useState, useEffect } from 'react';
import { ref, onValue } from 'firebase/database';
import { database } from '../firebase';
import './Features.css';

const ROTATE_INTERVAL_MS = 4000;
const COLS = 3;
const DEFAULT_SERVICE_AREAS = ['Yıldırım Mah', 'Kocatepe Mah', 'Kartaltepe Mah', 'Muratpaşa Mah'];
const WHATSAPP_NUMBER = '905403041414';

const Features = ({ onNavigate }) => {
  const [services, setServices] = useState([]);
  const [serviceAreas, setServiceAreas] = useState(DEFAULT_SERVICE_AREAS);
  const [pageIndex, setPageIndex] = useState(0);

  const handleTeklifAl = (serviceTitle) => {
    const message = `Merhaba, ${serviceTitle} hizmeti için teklif almak istiyorum.`;
    window.open(`https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`, '_blank');
  };

  useEffect(() => {
    const servicesRef = ref(database, 'services');
    const unsubscribe = onValue(servicesRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const servicesList = Object.keys(data).map(key => ({
          id: key,
          ...data[key]
        }));
        setServices(servicesList);
      } else {
        setServices([]);
      }
    });

    return () => unsubscribe();
  }, []);

  useEffect(() => {
    const contactRef = ref(database, 'contactInfo');
    const unsubscribe = onValue(contactRef, (snapshot) => {
      const data = snapshot.val();
      if (data && Array.isArray(data.serviceAreas) && data.serviceAreas.length > 0) {
        setServiceAreas(data.serviceAreas);
      } else {
        setServiceAreas(DEFAULT_SERVICE_AREAS);
      }
    });
    return () => unsubscribe();
  }, []);

  const totalPages = Math.max(1, Math.ceil(services.length / COLS));
  const start = pageIndex * COLS;
  const visibleServices = services.slice(start, start + COLS);

  useEffect(() => {
    if (services.length === 0) return;
    const timer = setInterval(() => {
      setPageIndex((prev) => (prev + 1) % totalPages);
    }, ROTATE_INTERVAL_MS);
    return () => clearInterval(timer);
  }, [services.length, totalPages]);

  return (
    <section id="features" className="features">
      <div className="container">
        {services.length === 0 ? null : (
          <>
            <div className="section-header">
              <h2 className="section-title">Hizmetlerimiz</h2>
              <p className="section-subtitle">
                Küçük ev aletleri satış ve tamiri, elektrik elektronik malzeme, ampul priz arıza giderimi, kapı kilit, kepenk kumanda, anahtar ve kumanda çoğaltma, kumanda pil değişimi.
              </p>
              <div className="section-areas-block">
                <span className="section-areas-label">Hizmet verdiğimiz semtler</span>
                <div className="section-areas-list">
                  {serviceAreas.map((area) => (
                    <span key={area} className="area-pill">{area}</span>
                  ))}
                </div>
              </div>
            </div>
            <div className="features-row">
              {Array.from({ length: COLS }, (_, i) => (
                <div key={visibleServices[i]?.id ?? `empty-${pageIndex}-${i}`} className="feature-card-wrap">
                  {visibleServices[i] ? (
                    <div className="feature-card">
                      <h3 className="feature-title">{visibleServices[i].title}</h3>
                      <p className="feature-description">{visibleServices[i].description}</p>
                      <button type="button" className="feature-teklif-btn" onClick={() => handleTeklifAl(visibleServices[i].title)}>
                        Teklif Al
                      </button>
                    </div>
                  ) : (
                    <div className="feature-card feature-card-empty" aria-hidden="true" />
                  )}
                </div>
              ))}
            </div>
            <div className="features-dots">
              {Array.from({ length: totalPages }, (_, i) => (
                <button
                  key={i}
                  type="button"
                  className={`features-dot ${i === pageIndex ? 'active' : ''}`}
                  onClick={() => setPageIndex(i)}
                  aria-label={`Sayfa ${i + 1}`}
                />
              ))}
            </div>
            {onNavigate && (
              <div className="features-cta">
                <button type="button" className="features-view-all-btn" onClick={() => onNavigate('services')}>
                  Tüm hizmetleri gör
                </button>
              </div>
            )}
          </>
        )}
      </div>
    </section>
  );
};

export default Features;
